module.exports = function() {
  return new Worker(__webpack_public_path__ + "b438565d765d3a7d8858.worker.js");
};